class ArrowKeysNavigation {
    constructor(elementId, containerSelector) {
        this.focusableItems = [];
        this.containerSelector = containerSelector;
        this.elementId = elementId;
        this.currentFocusedIndex = -1;
    }

    /** a11y: create list of focusable items. This could change during component life cycle, so this method should be called again in componentDidUpdate. */
    determineFocusable(containerSelector) {
        const element = document.getElementById(this.elementId);
        const focusableNodesSelector =
            'a[href], area[href], input, select, textarea, button:not([disabled]), [tabindex="0"]';

        if (!element) {
            return;
        }

        if (!containerSelector) {
            this.focusableItems = Array.from(element.querySelectorAll(focusableNodesSelector));
            return;
        }

        const contentContainer = element.querySelector(containerSelector);
        if (contentContainer) {
            this.focusableItems = Array.from(
                contentContainer.querySelectorAll(focusableNodesSelector)
            );
        }
    }

    _bindEvents() {
        this.focusableItems.forEach((node) => {
            node.addEventListener('blur', this._onBlur);
            node.addEventListener('focus', this._onFocus);
        });
    }

    _unbindEvents() {
        this.focusableItems.forEach((node) => {
            node.removeEventListener('blur', this._onBlur);
            node.removeEventListener('focus', this._onFocus);
        });
    }

    _onBlur = (e) => {
        this.currentFocusedIndex = -1;
    };

    _onFocus = (e: FocusEvent) => {
        this.currentFocusedIndex = this.focusableItems.indexOf(document.activeElement);
    };

    setFocusTo(index) {
        if (!this.focusableItems.length) {
            return;
        }
        if (!this.focusableItems[index]) {
            return;
        }
        this.focusableItems[index].focus();
    }

    getFocusIndex(newIndex) {
        if (newIndex > this.focusableItems.length - 1) {
            return 0;
        }
        if (newIndex < 0) {
            return this.focusableItems.length - 1;
        }
        return newIndex;
    }

    handleArrowKeys = (e) => {
        const keys = {
            DOWN: 40,
            RIGHT: 39,
            UP: 38,
            LEFT: 37,
        };

        if (e.keyCode === keys.DOWN || e.keyCode === keys.RIGHT) {
            e.preventDefault();
            this.setFocusTo(this.getFocusIndex(this.currentFocusedIndex + 1));
            return true;
        }

        if (e.keyCode === keys.UP || e.keyCode === keys.LEFT) {
            e.preventDefault();
            this.setFocusTo(this.getFocusIndex(this.currentFocusedIndex - 1));
            return true;
        }

        return false;
    };
}

export default ArrowKeysNavigation;
